// Reducer handlers
const reducerHandlers = {
  ['SET_TRUSTPILOT'](state, { payload }) {
    return {
      ...state,
      trustpilot: payload
    };
  }
};

export default reducerHandlers;
